import { ViteSSG } from 'vite-ssg'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { setupCookieConsent } from './plugins/cookieconsent'
import { routeConfigs, type RouteConfig } from './router/routes'
import { BookingUrls } from './constants/booking'
import MainLayout from './layouts/MainLayout.vue'
import type { RouteRecordRaw } from 'vue-router'

// Pre-discover all view components so dynamic imports work across subdirectories
const viewModules = import.meta.glob('./views/**/*View.vue');

// Generate Vue Router routes from the shared config
const childRoutes = routeConfigs.map((config: RouteConfig): RouteRecordRaw => {
  const fullLayout = config.fullLayout !== false;
  const viewImport = viewModules[`./views/${config.view}View.vue`];

  if (fullLayout) {
    return {
      path: config.path,
      name: config.name,
      meta: config.meta,
      components: {
        header: () => import('./layouts/HeaderNavView.vue'),
        default: viewImport,
        footer: () => import('./layouts/FooterView.vue'),
      },
    };
  } else {
    return {
      path: config.path,
      name: config.name,
      meta: config.meta,
      component: viewImport,
    };
  }
});

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: MainLayout,
    children: [
      ...childRoutes,
      // Catch-all: render 404 page in-place (keeps the original URL, no redirect)
      {
        path: ':pathMatch(.*)*',
        components: {
          header: () => import('./layouts/HeaderNavView.vue'),
          default: () => import('./views/NotFoundView.vue'),
          footer: () => import('./layouts/FooterView.vue'),
        },
      },
    ],
  },
];

export const createApp = ViteSSG(
  App,
  {
    routes,
    base: import.meta.env.BASE_URL,
  },
  ({ app, isClient }) => {
    app.use(vuetify);

    // Register global $bookingUrls property for easy access to booking URLs
    app.config.globalProperties.$bookingUrls = BookingUrls;

    // Setup cookie consent only on client side
    if (isClient) {
      setupCookieConsent();
    }
  }
);


